export const USER_COOKIE_CONSENT = "USER_COOKIE_CONSENT"
